import { render } from "./categoryManage.vue?vue&type=template&id=2c33a1d2&scoped=true"
import script from "./categoryManage.vue?vue&type=script&lang=js"
export * from "./categoryManage.vue?vue&type=script&lang=js"

import "./categoryManage.vue?vue&type=style&index=0&id=2c33a1d2&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c33a1d2"]])

export default __exports__